"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillDetailsToJSON = exports.BillDetailsFromJSONTyped = exports.BillDetailsFromJSON = exports.instanceOfBillDetails = void 0;
var runtime_1 = require("../runtime");
var BillAddress_1 = require("./BillAddress");
var BillCampaign_1 = require("./BillCampaign");
/**
 * Check if a given object implements the BillDetails interface.
 */
function instanceOfBillDetails(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBillDetails = instanceOfBillDetails;
function BillDetailsFromJSON(json) {
    return BillDetailsFromJSONTyped(json, false);
}
exports.BillDetailsFromJSON = BillDetailsFromJSON;
function BillDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
        'receiptNumber': !(0, runtime_1.exists)(json, 'receipt_number') ? undefined : json['receipt_number'],
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'campaigns': !(0, runtime_1.exists)(json, 'campaigns') ? undefined : (json['campaigns'].map(BillCampaign_1.BillCampaignFromJSON)),
        'billTo': !(0, runtime_1.exists)(json, 'bill_to') ? undefined : (0, BillAddress_1.BillAddressFromJSON)(json['bill_to']),
        'billFrom': !(0, runtime_1.exists)(json, 'bill_from') ? undefined : (0, BillAddress_1.BillAddressFromJSON)(json['bill_from']),
        'vatId': !(0, runtime_1.exists)(json, 'vat_id') ? undefined : json['vat_id'],
    };
}
exports.BillDetailsFromJSONTyped = BillDetailsFromJSONTyped;
function BillDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency_code': value.currencyCode,
        'receipt_number': value.receiptNumber,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(BillCampaign_1.BillCampaignToJSON)),
        'bill_to': (0, BillAddress_1.BillAddressToJSON)(value.billTo),
        'bill_from': (0, BillAddress_1.BillAddressToJSON)(value.billFrom),
        'vat_id': value.vatId,
    };
}
exports.BillDetailsToJSON = BillDetailsToJSON;
